export default __webpack_public_path__ + "static/media/profit_sharing_plan_light.647d23ad.png";